module.exports = require("./hsb");